/**
 * 業種選択モーダル
 * 特定の業種が選択された場合にモーダルを表示する
 */
export class IndustrySelectorModal {
  private selector: HTMLSelectElement | null;
  private modalBg: HTMLElement | null;
  private modalContent: HTMLElement | null;
  private closeButton: HTMLElement | null;
  private backButton: HTMLElement | null;

  // モーダルを表示する業種のリスト
  private readonly restrictedIndustries = [
    '不動産（仲介・販売）',
    '商社・建材店',
    '設計事務所',
    'その他'
  ];

  constructor(selectorClass: string = 'js-industry-selector') {
    console.log('[IndustrySelectorModal] Constructor called');

    this.selector = document.querySelector(`.${selectorClass}`);
    this.modalBg = document.querySelector('.js-modal-bg') as HTMLElement;
    this.modalContent = document.getElementById('js-modal-content');
    this.closeButton = document.getElementById('js-pop-close');
    this.backButton = document.getElementById('js-close-btn');

    if (!this.selector) {
      console.warn('[IndustrySelectorModal] Industry selector not found:', selectorClass);
      return;
    }

    console.log('[IndustrySelectorModal] Selector found:', this.selector);

    this.init();
  }

  /**
   * 初期化処理
   */
  private init(): void {
    console.log('[IndustrySelectorModal] init() called');

    if (!this.selector) {
      console.error('[IndustrySelectorModal] Selector is null in init()');
      return;
    }

    // 業種選択時のイベントリスナーを設定
    this.selector.addEventListener('change', () => {
      console.log('[IndustrySelectorModal] Industry changed:', this.selector?.value);
      this.handleIndustryChange();
    });

    // 閉じるボタンのイベントリスナーを設定
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => {
        console.log('[IndustrySelectorModal] Close button clicked');
        this.closeModal();
      });
    }

    // 戻るボタンのイベントリスナーを設定
    if (this.backButton) {
      this.backButton.addEventListener('click', () => {
        console.log('[IndustrySelectorModal] Back button clicked');
        this.closeModal();
      });
    }

    // 背景クリックでモーダルを閉じる
    if (this.modalBg) {
      this.modalBg.addEventListener('click', () => {
        console.log('[IndustrySelectorModal] Background clicked');
        this.closeModal();
      });
    }
  }

  /**
   * 業種変更時の処理
   */
  private handleIndustryChange(): void {
    if (!this.selector) return;

    const selectedValue = this.selector.value;
    console.log('[IndustrySelectorModal] Selected value:', selectedValue);
    console.log('[IndustrySelectorModal] Restricted industries:', this.restrictedIndustries);

    // 制限された業種が選択された場合、モーダルを表示
    if (this.restrictedIndustries.includes(selectedValue)) {
      console.log('[IndustrySelectorModal] Opening modal for restricted industry');
      this.openModal();
    }
  }

  /**
   * モーダルを開く
   */
  private openModal(): void {
    console.log('[IndustrySelectorModal] openModal() called');

    if (!this.modalBg || !this.modalContent) {
      console.error('[IndustrySelectorModal] Modal elements not found');
      return;
    }

    // モーダルを表示
    this.modalBg.classList.add('modal-open');
    this.modalContent.classList.add('open');

    // スクロールを防止
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    // selectの値を空に戻す
    if (this.selector) {
      this.selector.value = '';
      console.log('[IndustrySelectorModal] Reset selector value to empty');
    }
  }

  /**
   * モーダルを閉じる
   */
  private closeModal(): void {
    console.log('[IndustrySelectorModal] closeModal() called');

    if (!this.modalBg || !this.modalContent) {
      console.error('[IndustrySelectorModal] Modal elements not found');
      return;
    }

    // モーダルを非表示
    this.modalContent.classList.remove('open');
    this.modalBg.classList.remove('modal-open');

    // スクロールを再び有効化
    document.documentElement.style.overflow = 'auto';
    document.body.style.overflow = '';
  }
}
